import React from "react";

interface IParams {
  hasDocument: boolean;
  presentationId: number;
  expandedNode: string[];
  nodeId: string
}


const IsNodeExpand = (key: string,expandedNode: string[]) => {
    var ff= expandedNode.findIndex(x => x===key)
     if(ff>-1)
     return true;
     else
     return false;
  };

const TreeRepositoryIcon: React.FC<IParams> = ({ hasDocument,nodeId, presentationId ,expandedNode }) => {
 return (
    // ICONE FONTAWESOME
    <div className="odgIcon">
        {presentationId>0 ? (<> 
        
        { hasDocument ? (
          <i className="fas fa-file-alt"></i>
        )  : (
           <i className="fas fa-file"></i>
        )}
        </>)
        : (<>
           {IsNodeExpand(nodeId, expandedNode) ? 
           ( <i className="fas fa-folder-open"></i>) :
            (<i className="fas fa-folder"></i>)}
       
         </>)}
      </div>
     );
};

export default TreeRepositoryIcon;
